export default "<p>\n  Ermete Novelli (1851 - 1919), attore, è considerato uno dei più grandi maestri\n  dell'arte drammatica italiana.\n</p>\n";